import React, { useEffect, useMemo, useState } from "react";
import { Container, Typography, MenuItem, Select, Grid } from "@mui/material";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import {
  getEmisioensGeneralesAPI,
  getEmisionesMesDiaAPI,
} from "../../components/services/companyAPI";
import LoadingComponent from "../../widgets/LoadingComponent";
import moment from "moment";
import "moment/locale/es";

// Registrar módulos de Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

function EmisionGeneral() {
  const [loading, setLoading] = useState(false);
  const [emisiones, setEmisiones] = useState([]);
  const [emisionesDias, setEmisionesDias] = useState([]);
  // --- STATE para seleccionar dataset ---
  const [tipo, setTipo] = useState("anio");
  const [anioSelected, setAnioSelected] = useState(null);
  const [monthSelected, setMonthSelected] = useState(null);
  const dataValueArray = useMemo(() => {
    const result = {
      year: { label: [], total: [] },
      month: {},
    };

    emisiones?.year?.forEach((cc) => {
      //por año, select, data
      result.year.label.push(cc.anio);
      result.year.total.push(cc.total);

      //por mes, select, data
      if (anioSelected !== null) {
        if (cc.anio === anioSelected) {
          let resultMonthTotal = [];

          cc.month.forEach((ccx) => {
            resultMonthTotal.push(ccx.totalmonth);
          });

          result.month.total = resultMonthTotal;
        }
      }
    });

    return result;
  }, [emisiones, anioSelected]);

  // Generamos labels y data a partir del JSON
  const labels = emisionesDias.map((d) => moment(d.dia).date()); // → día del mes (1–31)
  const valores = emisionesDias.map((d) => d.totalDia);

  // --- DATASETS ---
  const dataDia = {
    labels,
    datasets: [
      {
        label: "Emisiones por día",
        data: valores,
        backgroundColor: "rgba(75, 192, 192, 0.5)",
      },
    ],
  };

  const dataMes = {
    labels: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ],
    datasets: [
      {
        label: "Emisiones por mes",
        data: dataValueArray?.month?.total,
        backgroundColor: "rgba(54, 162, 235, 0.5)",
      },
    ],
  };

  const dataAnio = {
    labels: dataValueArray.year.label,
    datasets: [
      {
        label: "Emisiones por año",
        data: dataValueArray.year.total,
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
    ],
  };

  const datasets = { mes: dataMes, dia: dataDia, anio: dataAnio };

  // --- OPCIONES dinámicas ---
  const options = {
    responsive: true,
    onClick: (event, elements) => {
      if (elements.length > 0) {
        const { datasetIndex, index } = elements[0];
        const dataset = datasets[tipo];
        const label = dataset.labels[index];
        const value = dataset.datasets[datasetIndex].data[index];

        if (tipo === "anio") {
          setAnioSelected(label);
          setTipo("mes");
        }

        if (tipo === "mes") {
          setMonthSelected(label);
          const numeroMes = moment().locale("es").month(label).month() + 1;
          getEmisionesMesDia(numeroMes);
          setTipo("dia");
        }
      }
    },
  };

  const getEmisionesGenerales = async () => {
    setLoading(true);
    const result = await getEmisioensGeneralesAPI();
    setEmisiones(result);
    setLoading(false);
  };

  const getEmisionesMesDia = async (numeroMes) => {
    if (!numeroMes) return;
    setLoading(true);
    const result = await getEmisionesMesDiaAPI(anioSelected, numeroMes);
    setEmisionesDias(result);
    setLoading(false);
  };

  useEffect(() => {
    getEmisionesGenerales();
  }, []);

  return (
    <Container style={{ padding: "1.5rem" }}>
      <LoadingComponent Loading={loading} />{" "}
      <Typography variant="h4" textAlign="center" gutterBottom>
        Emisiones Gráficos
      </Typography>
      <Typography variant="h4" textAlign="center" gutterBottom>
        {`${anioSelected || ""} - ${monthSelected || ""}`}
      </Typography>
      {/* Selector */}
      <div
        style={{
          display: "flex",
          justifyContent: "left",
          marginBottom: "1rem",
        }}
      >
        <Grid margin={"0 6rem"}>
          <Select
            value={tipo}
            onChange={(e) => {
              if (e.target.value === "anio") {
                setAnioSelected(null);
                setMonthSelected(null);
              }
              setTipo(e.target.value);
            }}
          >
            <MenuItem value="dia">Por día</MenuItem>
            <MenuItem value="mes">Por mes</MenuItem>
            <MenuItem value="anio">Por año</MenuItem>
          </Select>
        </Grid>
      </div>
      {/* Gráfico */}
      <Grid padding={"0 6rem"}>
        <Bar data={datasets[tipo]} options={options} />
      </Grid>
    </Container>
  );
}

export default EmisionGeneral;
